import api from './api';

// Drops null/undefined/empty filter params so the query string stays clean.
const clean = (params) => {
  const out = {};
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') out[key] = value;
  });
  return out;
};

export const getLeaveDashboardSummary = (params) => api.get('/v1/leave-dashboard/summary', { params: clean(params) });
export const getTodayOnLeave = (params) => api.get('/v1/leave-dashboard/today-on-leave', { params: clean(params) });
export const getDepartmentCapacity = (params) => api.get('/v1/leave-dashboard/department-capacity', { params: clean(params) });
export const getDensityMap = (params) => api.get('/v1/leave-dashboard/density-map', { params: clean(params) });
export const getUpcomingTimeline = (params) => api.get('/v1/leave-dashboard/upcoming-timeline', { params: clean(params) });
export const getApprovalPipeline = (params) => api.get('/v1/leave-dashboard/approval-pipeline', { params: clean(params) });
export const getBalanceDistribution = (params) => api.get('/v1/leave-dashboard/balance-distribution', { params: clean(params) });
export const getBurnoutRisk = (params) => api.get('/v1/leave-dashboard/burnout-risk', { params: clean(params) });
export const getRiskSignals = (params) => api.get('/v1/leave-dashboard/risk-signals', { params: clean(params) });
